// extracted by mini-css-extract-plugin
module.exports = {"paper":"ImageAlert_paper__HSJjM","container":"ImageAlert_container__DDwEs","cross":"ImageAlert_cross__UBfnZ"};